import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormControl } from '@angular/forms';
import { UserSessionService } from 'src/app/services/usersession.service';
import { UtilityService } from 'src/app/services/utility.service';
import * as moment from 'moment';
import { ReportsService } from 'src/app/services/reports.service';
import { VehicleService } from 'src/app/services/vehicle.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TripEntryService } from 'src/app/services/tripentry.service';
import { RegionService } from 'src/app/services/region.service';
import { DivisionService } from 'src/app/services/division.service';
import { SubDivisionService } from 'src/app/services/subdivision.service';
import { Observable } from 'rxjs';
import { RoleType } from 'src/enum/roletype';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { ExcelService } from 'src/app/services/excel.service';
import { AlertService } from 'src/app/services/alert.service';
import { warn } from 'console';
import * as _ from 'lodash';




@Component({
  selector: 'app-devicelog',
  templateUrl: './devicelog.component.html',
  styleUrls: ['./devicelog.component.scss'],

})
export class DevicelogComponent implements OnInit {
  excelData: any = [];
  public excelColumns: string[];
  isClientChanged = false;
  form: FormGroup;
  dropdownSettings: any = {};
  vehicledropdownSettings: any = {};
  vehicleList: any = [];
  tripTypeList: any[];
  CategoryTypeList: any[];
  displayedColumns: string[] = [
    'creationts',
    'gpsdevicets',
    'coordinates',
    'rawdata',
  ];
  loader: boolean = false;
  displayedColumnsfordevicelog: string[] = [


    'creationts',

    'packettype',
    'isonlinedata',
    'gpsfixstatus',

    'gpsdevicets',
    'latitude',
    'longitude',

    'speed',
    'direction',
    'noofsatellite',

    'altitude',
    'operatorname',
    'isignitionon',

    'ismainpowerconnected',
    'maininputvolt',
    'internalbatteryvolt',

    'isemergencystatuson',
    'istampered',
    'signalstrength',

    'odometer',
    'gpsmovestatustype',
    'gpsmovestatus',

    'networktype',
    'intervalduration',
    'address',
  ];
  data = [];
  dataSource = new MatTableDataSource(this.data);

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  clientId: any;
  vehicleRegNo: any[];
  scheduledEndmin: any;
  scheduledEndmax: any;
  maxDate: any;
  maxDatefromstart: any;

  VehicleTypeList: any[];
  registrationNumbers: any[];
  regionList: any[];
  vList: any[];
  divisionList: any[];
  subdivisionList: any[];
  VehicleRegNoList: any[];
  filterListregionList: any[];
  filterVList: any[];
  filterListdivisionList: any[];
  filterListsubdivisionList: any[];
  filterVehicleTypeList: any[];
  selectDatalist: any[];
  viList: any[];
  maxdayerror: boolean;

  public dateTime1: Date;
  public startAt = new Date();
  endAt: Date;

  public onlyDatePicker: boolean = true;
  public onlyTimePicker: boolean = false;
  SearchVehicleId: any;

  searchMoviesCtrl = new FormControl();
  filteredMovies: any;
  isLoading = false;
  errorMsg: string;
  http: any;
  roleId: number;
  public RoleEnumType = RoleType;
  access: boolean;
  rawdata: boolean = false;
  devicelog: boolean = false;
  isDropdownDisabled: boolean = false;
  showDevicelog: boolean = false;



  constructor(private formBuilder: FormBuilder,
    private excelService: ExcelService,
    private navigationService: NavigationService,
    private userSessionService: UserSessionService,
    private alertService: AlertService,
    private regionService: RegionService,
    private renderer: Renderer2,
    dateTimeAdapter: DateTimeAdapter<any>) {
    dateTimeAdapter.setLocale('en-IN')
    this.clientId = this.userSessionService.getCurrentClientId();
    this.VehicleTypeList = [];
    this.registrationNumbers = [];
    this.regionList = [];
    this.vList = [];
    this.divisionList = [];
    this.subdivisionList = [];
    this.VehicleRegNoList = [];
    this.filterListregionList = [];
    this.filterVList = [];
    this.filterListdivisionList = [];
    this.filterListsubdivisionList = [];
    this.filterVehicleTypeList = [];
    this.selectDatalist = [];
    this.roleId = this.userSessionService.roleId();

    this.maxDate = new Date();
  }

  ngOnInit() {
    this.initializeValidators();
    this.getLookupV(true)
  }


  initializeValidators() {
    this.form = this.formBuilder.group({
      searchVList: [''],
      IMEI: [''],
      ScheduledStart: [new Date(new Date().getTime() - 60 * 60 * 1000), Validators.required],
      ScheduledEnd: [new Date(), Validators.required]
    });
  }

  addDays(date: Date, days: number): Date {
    if (!date) {
      return null;
    }
    let result = new Date(date);
    const today = new Date();
    const diffTime = result.getTime() - today.getTime();
    const diffDays = diffTime / (1000 * 3600 * 24);

    if (diffDays <= -31) {
      result.setDate(result.getDate() + days);
    } else {
      result = new Date();
    }

    return result;
  }




  rawData() {
   
    if (this.form.value.searchVList != '' || this.form.value.IMEI != '') {

      this.loader = true
      const data = {
        vehicleId: this.form.value.searchVList != '' ? this.form.value.searchVList : 0,
        // vehicleId: 100,
        imeiNo: this.form.value.IMEI ? this.form.value.IMEI : 0,
        // imeiNo: 0,

        startTs: moment(this.form.value.ScheduledStart).format('yyyy-MM-DD HH:mm'),
        endTs: moment(this.form.value.ScheduledEnd).format('yyyy-MM-DD HH:mm')
      }
      
      this.regionService.gerRawData(data).subscribe(result => {
        if (result) {
          this.devicelog = false
          this.rawdata = true
          this.data = result
          this.excelData = [];
          this.excelData = result
          this.data=_.orderBy(result, ['gpsdevicets'], ['desc'])
          this.dataSource = new MatTableDataSource(this.data);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
        this.loader = false
      })
    }
    else {
      this.alertService.error('Please Select Machinery Reg.No Search or IMEI Number(Not Reg Machinery)')
    }

  }



  DeviceLog() {
    if (this.form.value.searchVList != '') {
      this.loader =true

      const data = {
        vehicleId: this.form.value.searchVList,
        // vehicleId: 1,
        startTs: moment(this.form.value.ScheduledStart).format('yyyy-MM-DD HH:mm'),
        endTs: moment(this.form.value.ScheduledEnd).format('yyyy-MM-DD HH:mm')
      }
      this.regionService.DeviceLogData(data).subscribe(result => {
        if (result) {
          this.rawdata = false
          this.devicelog = true
          this.data = result
          this.excelData = [];
          this.excelData = result
          this.data=_.orderBy(result, ['gpsdevicets'], ['desc'])

          this.dataSource = new MatTableDataSource(this.data);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        }
        this.loader =false
      })
    } else {
      this.alertService.error('Please Select Machinery Reg.No Search')
    }
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }



  getLookupV(refresh: boolean) {

    this.regionService.getVLookUp(refresh).subscribe(result => {
      if (result) {
        this.vList = [];
        this.filterVList = [];
        this.vList = result;
        this.filterVList = this.vList.slice();
        this.filterVList.forEach(element => {
          element.regNo = element.regNo + ' - ' + element.vehicleTypeName;
        });
      }
    })
  }

  changeClient(event) {
    this.SearchVehicleId = event.value
    // this.isClientChanged = true;
    const inputElement = document.getElementById('imeiInput');
    if (inputElement) {
      this.renderer.setAttribute(inputElement, 'disabled', 'true');
    }
  }


  IMEIChange() {
   
    if (this.form?.value?.IMEI?.length >= 1) {
      this.isDropdownDisabled = true;
      this.showDevicelog = true;
    }
    else {
      this.isDropdownDisabled = false;
      this.showDevicelog = false;
    }
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  Clear() {
    this.initializeValidators();
    const inputElement = document.getElementById('imeiInput');
    if (inputElement) {
      this.renderer.removeAttribute(inputElement, 'disabled');
    }
    this.isDropdownDisabled = false;
    this.showDevicelog = false;
    this.data = [];
    this.excelData = [];
    this.rawdata = false;
    this.devicelog = false;
    this.dataSource = new MatTableDataSource(this.data);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  // onChangeIsPicker(e) {
  //   if (e.target.value == "Yes") {
  //     this.onlyDatePicker = true;
  //     this.onlyTimePicker = false;

  //     this.form.controls['ScheduledEnd'].clearValidators();
  //     this.form.controls['ScheduledEnd'].updateValueAndValidity();
  //   } else {
  //     this.onlyDatePicker = false;
  //     this.onlyTimePicker = true;

  //     this.form.controls['ScheduledEnd'].setValidators(Validators.required);
  //     this.form.controls['ScheduledEnd'].updateValueAndValidity();

  //   }
  // }

  exportAsXLSXRawdata() {
    var exportData = this.excelData
    if (!exportData || exportData.length === 0) {
      this.alertService.info('No data available to export');
      return;
    }

    this.excelColumns = [
      'Data Received Time',
      'GPS Device Date and Time',
      'Coordinates',
      'Raw Data',
    ];


    const excelList = [];
    exportData.forEach(a => {

      excelList.push({
        'Data Received Time':  moment(a.creationts).format('DD/MM/yyyy hh:mm A'),
        'GPS Device Date and Time': moment(a.gpsdevicets).format('DD/MM/yyyy hh:mm A'),
        'Coordinates': a.coordinates,
        'Raw Data': a.rawdata
      });
    });

    this.excelService.exportAsExcelFile(excelList, 'Rawdata', this.excelColumns);
  }












  exportAsXLSXDevicelog() {
    var exportData = this.excelData
    if (!exportData || exportData.length === 0) {
      this.alertService.info('No data available to export');
      return;
    }

    this.excelColumns = [
      'Data Received Time',
      'Packet Type',
      'Is Online Data',
      'GPS Fix Status',
      'GPS Device TS',

      'Latitude',
      'Longitude',
      'Speed',
      'Direction',
      'No Of Satellite',
      'Altitude',

      'Operator Name',
      'Is Ignition On',
      'Is Mainpower Connected',
      'Main Input Volt',
      'Internal Battery Volt',

      'Is Emergency Status On',
      'Is Tampered',
      'Signal Strength',
      'Odometer',
      'GPS Move Status Type',

      'GPS Move Status',
      'Network Type',
      'Interval Duration',
      'Address'
    ];


    const excelList = [];
    exportData.forEach(a => {

      excelList.push({
        'Data Received Time':  moment(a.creationts).format('DD/MM/yyyy hh:mm A'),
        'Packet Type': a.packettype,
        'Is Online Data': a.isonlinedata,
        'GPS Fix Status': a.gpsfixstatus,
        'GPS Device TS':  moment(a.gpsdevicets).format('DD/MM/yyyy hh:mm A'),

        'Latitude': a.latitude,
        'Longitude': a.longitude,
        'Speed': a.speed,
        'Direction': a.direction,
        'No Of Satellite': a.noofsatellite,
        'Altitude': a.altitude,

        'Operator Name': a.operatorname,
        'Is Ignition On': a.isignitionon,
        'Is Mainpower Connected': a.ismainpowerconnected,
        'Main Input Volt': a.maininputvolt,
        'Internal Battery Volt': a.internalbatteryvolt,

        'Is Emergency Status On': a.isemergencystatuson,
        'Is Tampered': a.istampered,
        'Signal Strength': a.signalstrength,
        'Odometer': a.odometer,
        'GPS Move Status Type': a.gpsmovestatustype,

        'GPS Move Status': a.gpsmovestatus,
        'Network Type': a.networktype,
        'Interval Duration': a.intervalduration,
        'Address': a.address
      });
    });

    this.excelService.exportAsExcelFile(excelList, 'DeviceLog', this.excelColumns);
  }
}
